import Weather from "./Weather";



function App() {
  return (
    <div className = "wallpaper">
    <div className="App">
      <div className = "container">
        <Weather defaultCity = "Paris"/>
      <footer className="App-footer">
      </footer>
      </div>
    </div>
    </div>
  );
}

export default App;
